// « + » d'ajout rapide dans le tiroir panier (WEBLCFB2C-202).
// Une seule variante (data-variant) : ajout direct. Sinon, la MÊME pop-up que le « + » des cartes
// collection (quick-buy-modal de Prestige), ouverte sur la variante du téléphone déjà au panier,
// sinon du téléphone mémorisé par le filtre des collections (cookie selectedPhone).
(() => {
  const PHONE_OPTION = 'Mobile';

  let pending = false;
  const drawer = () => document.querySelector('cart-drawer');

  function rememberedPhone() {
    try {
      const giftNode = drawer()?.querySelector('[data-df-gift]');
      const fromCart = giftNode ? JSON.parse(giftNode.textContent).phone : '';
      if (fromCart) return fromCart;
      const cookie = document.cookie.split('; ').find((c) => c.startsWith('selectedPhone='));
      return cookie ? decodeURIComponent(cookie.slice('selectedPhone='.length)) : '';
    } catch {
      return '';
    }
  }

  async function addVariant(id, button) {
    window.dfCartPending?.start(describe(button));
    try {
      await window.dfCartActions.add({ items: [{ id: Number(id), quantity: 1 }] });
    } finally { window.dfCartPending?.stop(); }
  }

  // Ce que montre la ligne « en cours » : la tuile ou l'encart d'où part le « + ».
  function describe(button) {
    const box = button?.closest('.df-cart__tile, .df-cart__booster');
    const img = box?.querySelector('img');
    const name = box?.querySelector('.df-cart__tile-title, strong');
    return { title: name?.textContent.trim() || '', image: img?.currentSrc || img?.src || '' };
  }

  /** Variante d'ouverture : disponible, sur le téléphone connu s'il existe pour ce produit. */
  function openingVariant(product) {
    const phoneIndex = product.options.findIndex((option) => option.name === PHONE_OPTION);
    const phone = phoneIndex === -1 ? '' : rememberedPhone();
    const available = product.variants.filter((v) => v.available);
    return (phone && available.find((v) => v.options[phoneIndex] === phone)) || available[0] || product.variants[0];
  }

  async function openQuickBuy(button) {
    const response = await fetch(`${Shopify.routes.root}products/${button.dataset.handle}.js`);
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    const id = `df-cart-quick-buy-${product.id}`;
    let modal = document.getElementById(id);
    if (!modal) {
      modal = document.createElement('quick-buy-modal');
      modal.id = id;
      modal.className = 'quick-buy-modal modal';
      modal.setAttribute('aria-label', button.getAttribute('aria-label') || product.title);
      document.body.append(modal);
    }
    modal.setAttribute('handle', `${product.handle}?variant=${openingVariant(product).id}`);
    try {
      await modal.show();
    } catch (error) {
      // Prestige starts its progress indicator before fetching the modal content.
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      throw error;
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('cart-drawer [data-df-quick-add]');
    if (!button) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    drawer()?.querySelector('[data-df-action-error]')?.remove();
    try {
      if (button.dataset.variant) await addVariant(button.dataset.variant, button);
      else await openQuickBuy(button);
    } catch (error) {
      window.dfCartActions.report(button.dataset.variant ? error : new Error(drawer()?.dataset.dfRequestErrorText || 'Please try again.'));
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      pending = false;
    }
  });
})();
